import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'torchUnitStatuses'
})
export class TorchUnitStatusPipe implements PipeTransform {

  private statuses = {
    S: 'Serviceable',
    I: 'Installed',
    U: 'Unserviceable',
    P: 'Pending Install'
  }

  transform(value: string, ...args: unknown[]): string {
    let returnValue = value;

    Object.keys(this.statuses).forEach(key => {
      returnValue = returnValue.replace(key, this.statuses[key]);
    });

    return  returnValue;
  }

}
